export default "__VITE_ASSET__DCYJLrid__"